import React, { FunctionComponent, useEffect, useRef, useState } from "react";
import TextareaFieldContent from "./TextareaFieldContent.model";
import styles from "./TextareaField.module.scss";
import combineClasses from "helpers/combine-classes";

const TextareaField: FunctionComponent<TextareaFieldContent> = (props) => {
    const { setFormFieldsState, formFieldsState, setRequiredFieldsEach, requiredFieldsEach, setIsAlert, isAlert, resetFields } = props;
    const [fieldValue, setFieldValue] = useState("");
    const ref = useRef<HTMLTextAreaElement>(null);

    useEffect(() => {
        if (resetFields && ref.current) { ref.current.value = "", setFieldValue(""); }
    }, [resetFields]);

    const handleChange = (e: React.FormEvent<HTMLTextAreaElement>) => {
        const el = e.target as HTMLInputElement;

        const includesAlias = requiredFieldsEach.length > 0 ? requiredFieldsEach.includes(props.alias) : false;
        if (props.mandatory && el.value.length > 0 && !includesAlias) {
            setRequiredFieldsEach([...requiredFieldsEach, props.alias]);
        }

        if (props.mandatory && el.value.length === 0 && includesAlias) {
            setRequiredFieldsEach(requiredFieldsEach.filter(e => e !== props.alias));
            setIsAlert(true);
        }

        setFormFieldsState({ ...formFieldsState, [el.name]: el.value });
        if (ref.current) setFieldValue(ref.current.value);
    };

    const alertClass = fieldValue === "" && props.mandatory && isAlert ? styles.alert : undefined;

    return (
        <div className={styles.textarea_field}>
            <label>
                <div className={styles.label_wrapper}>
                    <span className={styles.label}>{props.caption}</span> {props.mandatory ? (<span className={styles.mandatory}>*</span>) : null}
                </div>
                <textarea onChange={handleChange} ref={ref} className={combineClasses([styles.textarea, alertClass])} name={props.alias} />
            </label>
        </div>
    );
};

export default TextareaField;
